export default "__VITE_ASSET__CSrX3Z4z__"